import { OrderPlanningSplitView } from "../OrderPlanningSplitView";
import { DataSource, Image, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutOperationsManagementMultiProfile extends Layout {
    imageOrdersEquipmentHorizontal: Image;
    imageOrdersEquipmentVertical: Image;
    imageOrdersTimelineVertical: Image;
    layoutOrderPlanningSplitView: OrderPlanningSplitView;
    sourceAvailableMove: DataSource;
    sourceEquipMoveDriver: DataSource;
    sourceEquipMoveTractor: DataSource;
    sourceOrderPlanningProfile: DataSource;
    tabProfile: Tab;
    tabsetOrderPlanningProfiles: Tabset;
}
